import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { formatPriceOnUserLocale } from '../../views/settings/billing/functions/billingUtils';
import '../../style/scss/billing.scss';

interface ModulePriceBoxProps {
    priceType?: string;
    flatPrice?: string;
    pricePerSeat?: string;
    amount?: number;
    unitLabel?: string;
};

// Orange styled price box showing the monthly price of a module or integration
const ModulePriceBox: React.FC<ModulePriceBoxProps> = ({ priceType, flatPrice, pricePerSeat, amount, unitLabel }) => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    // Use the given amount or derive the monthly unit price from the price type
    const modulePrice = amount !== undefined
        ? amount
        : priceType === 'per_seat'
            ? parseFloat(pricePerSeat ?? '0')
            : parseFloat(flatPrice ?? '0');

    // Use the given unit label or derive it from the price type
    const priceUnitLabel = unitLabel !== undefined
        ? unitLabel
        : priceType === 'per_seat'
            ? t('billing.module_price.unit_license_label')
            : t('billing.module_price.unit_company_label');

    return (
        <div className='module-price-box'>
            <div className='price-label'>
                <span className='currency-icon'>€ </span>
                {formatPriceOnUserLocale(modulePrice, userLocale)}
                <span className='price-period'> {t('billing.module_price.per_month_suffix')}</span>
            </div>
            {priceUnitLabel && (
                <div className='price-unit-label'>
                    {priceUnitLabel}
                </div>
            )}
        </div>
    );
};

export default ModulePriceBox;
